export default __webpack_public_path__ + "static/media/wind.69afd1c1.svg";